import { QueryClient } from '@tanstack/react-query';

/**
 * React Query Client 설정
 *
 * V2 REST API를 위한 전역 QueryClient
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5분
      gcTime: 10 * 60 * 1000, // 10분 (React Query v5에서 cacheTime → gcTime으로 변경)
    },
    mutations: {
      retry: 0,
    },
  },
});
